import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createCalculationAsync, deleteCalculationByIdAsync, getAllCalculationsByWorkOrderIDAsync, getCalculationByIDAsync, updateBulkCalcualtionAsync, updateCalculationAsync, updateCalculationPositionAsync } from './CalculationThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const calculationSlice = createSlice({
    name: 'calculations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllCalculationsByWorkOrderIDAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllCalculationsByWorkOrderIDAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.calculations = action.payload;
        })
            .addCase(getAllCalculationsByWorkOrderIDAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getCalculationByIDAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCalculationByIDAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.calculation = action.payload;
        })
            .addCase(getCalculationByIDAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createCalculationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createCalculationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.createdCalculation = action.payload;
        })
            .addCase(createCalculationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateCalculationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCalculationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updatedCalculation = action.payload;
        })
            .addCase(updateCalculationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteCalculationByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteCalculationByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            // state.deleteProgressNotes=action.payload;
        })
            .addCase(deleteCalculationByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateCalculationPositionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateCalculationPositionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateCalculationPositionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateBulkCalcualtionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateBulkCalcualtionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(updateBulkCalcualtionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default calculationSlice.reducer;
